module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_9005.daaaf2d6.png";